<div class="modal-header">
  <h4 class="modal-title">Захранване на сметка</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <span class="form-label">Начин на плащане*</span>
      @for (option of invoicePaymentOptions; track option.invoicePaymentOptionId) {
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            [id]="'paymentOption' + option.invoicePaymentOptionId"
            formControlName="invoicePaymentOptionId"
            [value]="option.invoicePaymentOptionId">
          <label
            class="form-check-label"
            [for]="'paymentOption' + option.invoicePaymentOptionId">
            {{ option.invoicePaymentOptionName }}
          </label>
        </div>
      }
    </fieldset>
    <fieldset class="mb-4">
      <label for="amount" class="mb-0 form-label">Сума в лева*</label>
      <input
        id="amount"
        type="number"
        formControlName="amount"
        class="form-control"
        placeholder="Въведете сума..."
        aria-label="Сума"
        [class.is-valid]="amount?.touched && amount?.valid"
        [class.is-invalid]="amount?.touched && amount?.invalid">
      <p class="m-0 invalid-feedback">Задължително поле по-голямо или равно на 1 лев!</p>
    </fieldset>
    <fieldset>
      <div class="form-check">
        <input
          type="checkbox"
          id="needInvoice"
          class="form-check-input"
          formControlName="needInvoice">
        <label class="form-check-label" for="needInvoice">
          Желая да ми бъде издадена фактура
        </label>
      </div>
    </fieldset>
    @if (needInvoice?.value) {
      <hr/>
      <fieldset class="my-3">
        <span class="form-label">Изберете за кого да бъде издадена фактурата:</span>
        <div class="form-check">
          <input
            type="radio"
            id="legalEntity"
            class="form-check-input"
            formControlName="selectedInvoiceType"
            [value]="InvoiceType.Legal">
          <label for="legalEntity" class="form-check-label">Юридическо лице (фирма)</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="physicalPerson"
            class="form-check-input"
            formControlName="selectedInvoiceType"
            [value]="InvoiceType.Physical">
          <label for="physicalPerson" class="form-check-label">Физическо лице</label>
        </div>
      </fieldset>
      @if (!!selectedInvoiceType?.value && selectedInvoiceType?.value === InvoiceType.Legal) {
        <fieldset class="mb-3">
          <label for="companyName" class="mb-0 form-label">Наименование на фирмата*</label>
          <input
            id="companyName"
            type="text"
            class="form-control"
            formControlName="companyName"
            placeholder="Въведете наименование на фирмата..."
            [class.is-invalid]="companyName?.touched && companyName?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
        <fieldset class="mb-3">
          <label for="companyBulstat" class="mb-0 form-label">ЕИК/Булстат*</label>
          <input
            id="companyBulstat"
            type="text"
            class="form-control"
            formControlName="companyBulstat"
            placeholder="Въведете ЕИК/Булстат..."
            [class.is-invalid]="companyBulstat?.touched && companyBulstat?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
        <fieldset class="mb-3">
          <label for="companyVatNumber" class="mb-0 form-label">Идентификационен номер по ДДС</label>
          <input
            id="companyVatNumber"
            type="text"
            class="form-control"
            formControlName="companyVatNumber"
            placeholder="Въведете ДДС номер (ако е приложимо)">
        </fieldset>
        <fieldset class="mb-3">
          <label for="companyMol" class="mb-0 form-label">МОЛ (управител или представител)*</label>
          <input
            id="companyMol"
            type="text"
            class="form-control"
            formControlName="companyMol"
            placeholder="Въведете името на представляващото лице..."
            [class.is-invalid]="companyMol?.touched && companyMol?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
        <fieldset>
          <label for="companyAddress" class="mb-0 form-label">Адрес на фирмата*</label>
          <input
            id="companyAddress"
            type="text"
            class="form-control"
            formControlName="companyAddress"
            placeholder="Въведете адрес на фирмата..."
            [class.is-invalid]="companyAddress?.touched && companyAddress?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
      } @else if (!!selectedInvoiceType?.value && selectedInvoiceType?.value === InvoiceType.Physical) {
        <div class="alert alert-primary">
          Въведените лични данни ще бъдат използвани единствено с цел издаване и изпращане на фактура. Данните се
          обработват съгласно <strong>Политиката за защита на личните данни</strong>.
        </div>
        <fieldset class="mb-3">
          <label for="personFullName" class="mb-0 form-label">Три имена*</label>
          <input
            id="personFullName"
            type="text"
            class="form-control"
            formControlName="personFullName"
            placeholder="Въведете име, презиме и фамилия..."
            [class.is-invalid]="personFullName?.touched && personFullName?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
        <fieldset class="mb-3">
          <label for="personIdentifier" class="mb-0 form-label">Личен идентификатор (ЕГН)*</label>
          <input
            id="personIdentifier"
            type="text"
            class="form-control"
            formControlName="personIdentifier"
            placeholder="Въведете личен идентификатор..."
            [class.is-invalid]="personIdentifier?.touched && personIdentifier?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
        <fieldset>
          <label for="personAddress" class="mb-0 form-label">Адрес*</label>
          <input
            id="personAddress"
            type="text"
            class="form-control"
            formControlName="personAddress"
            placeholder="Въведете адрес..."
            [class.is-invalid]="personAddress?.touched && personAddress?.invalid">
          <div class="m-0 invalid-feedback">Задължително поле.</div>
        </fieldset>
      }
    }
  </form>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Продължи</span>
  </button>
</div>
